<template>
	
<div id="payZfb">
	<div class="paySuc-sec"> 
	<!-- // v-if="isWXUA" -->
		<div class="img-group">
			<div class="suc-img">
				<span class="pay-zfb-icon"></span>
				<img src="../../assets/images/payXfb.png" alt="">
			</div>
		</div>
		<div>
			<p class="tips">请在菜单中选择在浏览器中打开，<br/>以完成支付~</p>
		</div>
		<div class="suc-operate-group">
			<span class="op-items" @click="checkPaySec(0)">已完成支付</span>
			<span class="op-items" @click="checkPaySec(1)">返回</span>
		</div>
	</div>
</div>
</template>
<script>
	import normalBar from '@/components/common/navbar/normalBar'
	import pingpp from 'pingpp-js'
	import { mapState } from 'vuex'
	import { Toast } from '@/js/mint-ui';
	import api from '@/api/api'
	import payHelper from '@/js/payHelper'
  import commonApi from '@/api/common/api.common'


	export default {
		data(){
			return {
				isWX: false
			}
		},
		computed: {
      		isWXUA () {
        		return this.utils.isWXUA()
     		},
    	},
		components: {
			normalBar
		},
		created(){
			let payNo = this.$route.params.payNo;

			if(!this.isWXUA){
        		commonApi.getPayInfo({
					cancelUrl: window.location.origin+'/#/payZfbTips',//	取消支付返回的url	string
					payNo: payNo,//	支付号	string	
					successUrl:window.location.origin+'/#/payZfbTips',
					payType: 2
				},function(respond){
					payHelper.dealPay('AliH5', respond.body.data.content)

				})
			}
		},
		methods:{
			checkPaySec(type){
				let self = this;
				let payNo = this.$route.params.payNo;

				// self.$router.push({
				// 	path: '/orderDetails/'+self.merchantId
				// });

        commonApi.getPayResult({
						payNo: payNo
					},function(json){
						let res = json.body;
						self.success = res.data.paySuccess;
						self.mchId = res.data.merchantId

						if(res.data.paySuccess){
							self.$router.push({
								path: '/paySuccess/'+res.data.merchantId
							})
						}else {
							
							if(type == 0){
								Toast('支付失败');
							}
							setTimeout(function(){
								self.$router.push({
									path: '/orderDetails/'+res.data.merchantId
								})
							},2000);
						}
					}
				)

			}
		}

	}
</script>
<style lang="scss">
    @import '../../assets/css/mixin';
	

	

</style>


// WEBPACK FOOTER //
// payZFB.vue?d8866dfc